import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import LoadingSpinner from '../../../components/LoadingSpinner';

import Source from '../Source';
import ThingSpeakChannel from '../../channel/thingSpeak';
import AirQualityData from '../../data/airQuality/index';
import ThingSpeakToAirQuality from './interfaces/ThingSpeakToAirQuality';

import store from '../../../store/configureStore';

export default class ThingSpeakSource extends Source {
  current_page = 0;
  per_page = 5;
  total_entries = 0;
  channels = new Map();
  feeds = [];
  static get ACTIONS() {
    return {
      ADD_THINGSPEAK_CHANNEL_TO_STORE: 'ADD_THINGSPEAK_CHANNEL_TO_STORE',
      REMOVE_FROM_STORE: 'REMOVE_FROM_STORE',
      FETCHING_CHANNELS_DATA: 'FETCHING_CHANNELS_DATA',
      ADD_CHANNELS_DATA: 'ADD_CHANNELS_DATA',
      FETCHING_CHANNELS_DATA_COMPLETE: 'FETCHING_CHANNELS_DATA_COMPLETE',
      FETCH_CHANNELS_FAILED: 'FETCH_CHANNELS_FAILED',
      FETCHING_FEED_DATA: 'FETCHING_FEED_DATA',
      ADD_FEED_DATA: 'ADD_FEED_DATA',
      FETCHING_FEED_DATA_COMPLETE: 'FETCHING_FEED_DATA_COMPLETE',
      FETCH_FEED_FAILED: 'FETCH_FEED_FAILED'
    };
  }
  static register(source) {
    store.dispatch({
      type: ThingSpeakSource.ACTIONS.ADD_THINGSPEAK_CHANNEL_TO_STORE,
      source: source
    });
  }
  static unregister(source) {
    store.dispatch({
      type: ThingSpeakSource.ACTIONS.REMOVE_FROM_STORE,
      source: source
    });
  }
  constructor(initializer = {}) {
    super(initializer);
    Object.assign(this, initializer);
  }
  addChannelsData(data = {}) {
    if((data)&&(data.pagination)&&(data.pagination.current_page)) {
      this.current_page = data.pagination.current_page;
      this.per_page = data.pagination.per_page;
      this.total_entries = data.pagination.total_entries;
    }
    if((data)&&(data.channels)&&(data.channels.length > 0)) {
      data.channels.map((channel) => {
        let thingSpeakChannelObject = new ThingSpeakChannel(channel);
        this.channels.set(thingSpeakChannelObject.uid, thingSpeakChannelObject);
      });
    }
  }
  setFetchingChannelsFlag() {
    return ({
      type: ThingSpeakSource.ACTIONS.FETCHING_CHANNELS_DATA,
      uid: this.uid
    });
  }
  setChannelsFetchCompleteFlag() {
    return ({
      type: ThingSpeakSource.ACTIONS.FETCHING_CHANNELS_DATA_COMPLETE,
      uid: this.uid
    });
  }
  fetchChannelsFailed(error) {
    return({
      type: ThingSpeakSource.ACTIONS.FETCH_CHANNELS_FAILED,
      error: error,
      uid: this.uid
    });
  }
  fetchChannels() {
    store.dispatch(this.setFetchingChannelsFlag());
    fetch((this.url + 'channels/public.json?tag=aqm&page='
      + (this.current_page + 1) + '&per_page=' + this.per_page))
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        store.dispatch({
          type: ThingSpeakSource.ACTIONS.ADD_CHANNELS_DATA,
          data: data,
          uid: this.uid
        });
        if((data)&&(data.channels)&&(data.channels.length > 0)) {
          data.channels.map((channel) => {
            if(channel&&channel.id) {
              this.fetchFeed(channel.id);
            }
          });
        }
      },
      error => {
        store.dispatch(this.fetchChannelsFailed(error));
      });
    if(this.current_page < ((this.total_entries/this.per_page))) {
      this.fetchChannels();
    }
    else {
      store.dispatch(this.setChannelsFetchCompleteFlag());
    }
  }
  addFeedData(data = {}, channelID) {
    if((data)&&(data.feeds)&&(data.feeds.length > 0)) {
      this.feeds = this.feeds.concat(data.feeds.map((feed) => {
        return Object.assign({}, feed, {
          channel: channelID
        });
      }));
    }
  }
  setFetchingFeedFlag() {
    return ({
      type: ThingSpeakSource.ACTIONS.FETCHING_FEED_DATA,
      uid: this.uid
    });
  }
  setFeedFetchCompleteFlag() {
    return ({
      type: ThingSpeakSource.ACTIONS.FETCHING_FEED_DATA_COMPLETE,
      uid: this.uid
    });
  }
  fetchFeedSuccess(data, channelID) {
    new ThingSpeakToAirQuality(data, this.uid);
    return({
      type: ThingSpeakSource.ACTIONS.ADD_FEED_DATA,
      data: data,
      uid: this.uid,
      channelID: channelID
    });
  }
  fetchFeedFailed(error, channelID) {
    return({
      type: ThingSpeakSource.ACTIONS.FETCH_FEED_FAILED,
      error: error,
      uid: this.uid,
      channelID: channelID
    });
  }
  fetchFeed(channelID) {
    store.dispatch(this.setFetchingFeedFlag(channelID));
    fetch((this.url + 'channels/' + channelID + '/feed.json'))
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        store.dispatch(this.fetchFeedSuccess(data, channelID));
      },
      error => {
        store.dispatch(this.fetchFeedFailed(error, channelID));
      });
    store.dispatch(this.setFeedFetchCompleteFlag());
  }

  static reducer(state = {}, action) {
    switch(action.type) {
      case ThingSpeakSource.ACTIONS.ADD_THINGSPEAK_CHANNEL_TO_STORE: {
        let sources = state.sources;
        sources.set(action.source.uid, action.source);
        return Object.assign(state, {
          sources: sources
        });
      }
      case ThingSpeakSource.ACTIONS.REMOVE_FROM_STORE: {
        let sources = state.sources;
        if(sources.has(action.source.uid)) {
          sources.delete(action.source.uid);
        }
        return Object.assign(state, {
          sources: sources
        });
      }

      case ThingSpeakSource.ACTIONS.FETCHING_CHANNELS_DATA: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.channelsAreLoading = true;
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }
      case ThingSpeakSource.ACTIONS.ADD_CHANNELS_DATA: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.addChannelsData(action.data);
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }
      case ThingSpeakSource.ACTIONS.FETCHING_CHANNELS_DATA_COMPLETE: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.channelsAreLoading = false;
        source.channelsAreLoaded = true;
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }

      case ThingSpeakSource.ACTIONS.FETCHING_FEED_DATA: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.feedsAreLoading = true;
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }
      case ThingSpeakSource.ACTIONS.ADD_FEED_DATA: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.addFeedData(action.data, action.channelID);
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }
      case ThingSpeakSource.ACTIONS.FETCHING_FEED_DATA_COMPLETE: {
        let sources = state.sources;
        let source = state.sources.get(action.uid);
        source.feedsAreLoading = false;
        source.feedsAreLoaded = true;
        sources.set(action.uid, source);
        return Object.assign(state, {
          sources: sources
        });
      }

      default: {
        return state;
      }
    }
  }

  displayList() {
    return <ThingSpeakSourceList key={Math.random()} id={this.uid} />;
  }

}

class ThingSpeakSourceListLOC extends React.Component {
  constructor (props, context) {
    super(props, context);
    let channelsList = (Array.from((props.thingSpeak.sources.get(props.id)).channels))
      .map(([key, value]) => value);
    this.state = {
      channels: {
        areLoaded: (props.thingSpeak.sources.get(props.id)).channelsAreLoaded,
        areLoading: (props.thingSpeak.sources.get(props.id)).channelsAreLoading,
        list: channelsList
      }
    };
  }
  componentWillReceiveProps(nextProps) {
    let channelsList = (Array.from((nextProps.thingSpeak.sources.get(nextProps.id)).channels))
      .map(([key, value]) => value);
    this.setState({
      channels: {
        areLoaded: (nextProps.thingSpeak.sources.get(nextProps.id)).channelsAreLoaded,
        areLoading: (nextProps.thingSpeak.sources.get(nextProps.id)).channelsAreLoading,
        list: channelsList
      }
    });
  }
  render() {
    let channels = this.state.channels.list;
    if(channels.length === 0) {
      if(this.state.channels.areLoading)
        return <LoadingSpinner />;
      else {
        return <div>
          Nothing to show
        </div>;
      }
    }
    return <Table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Description</th>
          <th>Location</th>
        </tr>
      </thead>
      <tbody>
        {
          channels.map((channel) => <tr key={Math.random()}>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
          </tr>)
        }
      </tbody>
    </Table>;
  }
}

const ThingSpeakSourceList = connect((state, ownProps) => {
  return ({
    thingSpeak: state.thingSpeak
  });
})(ThingSpeakSourceListLOC);



// WEBPACK FOOTER //
// ./src/models/source/thingSpeak/ThingSpeakSource.js